export function contractDate(value) {
  const match = String(value ?? "").match(/^(\d{4})-?(\d{2})-?(\d{2})(?:$|T)/);
  if (!match) return null;
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return date.getFullYear() === Number(match[1]) && date.getMonth() === Number(match[2]) - 1 && date.getDate() === Number(match[3]) ? date : null;
}
export function contractTime(value) {
  const match = String(value ?? "").trim().match(/^(\d{1,2})(?:\s*[:hH]\s*|:)?(\d{2})(?::\d{2})?$/);
  if (!match || Number(match[1]) > 23 || Number(match[2]) > 59) return null;
  return `${match[1].padStart(2, "0")}:${match[2]}`;
}
export function missionOnDay(contract, day) {
  const start = contractDate(contract.DateDebut);
  const end = contractDate(contract.DateFinMission || contract.DateFin) || start;
  return Boolean(start && end && start <= day && day <= end);
}
export function monday(date) {
  const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  result.setDate(result.getDate() - (result.getDay() + 6) % 7);
  return result;
}

const firstTime = (contract, keys) => {
  for (const key of keys) {
    const time = contractTime(contract?.[key]);
    if (time) return time;
  }
  return null;
};

/** Début / fin réels : HeureDebut/HeureFin, startHour/endHour, ou horaires PLD (HoraireAMDebut → HorairePMFin). */
export function contractSchedule(contract = {}) {
  let start = firstTime(contract, ["HeureDebut", "startHour", "startHourString", "HoraireAMDebut", "HoraireDebutPremier", "HorairePMDebut"]);
  let end = firstTime(contract, ["HeureFin", "endHour", "endHourString", "HorairePMFin", "HoraireAMFin"]);
  if (!start || !end) {
    const parts = String(contract.Horaires || "")
      .split(/\s*(?:→|->|–|—|-|à)\s*/i)
      .map(contractTime)
      .filter(Boolean);
    if (!start && parts[0]) start = parts[0];
    if (!end && parts[1]) end = parts[1];
  }
  if (start && end) return { start, end, label: `${start} → ${end}` };
  const text = String(contract.Horaires || "").trim();
  if (text) return { start: null, end: null, label: text };
  return { start: null, end: null, label: "Horaires non renseignés" };
}
